import * as FlightsActions from './flights.actions';

export default FlightsActions;
